const DangerIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 1C7.23478 1 6.98043 1.10536 6.79289 1.29289L1.29289 6.79289C1.10536 6.98043 1 7.23478 1 7.5V16.5C1 16.7652 1.10536 17.0196 1.29289 17.2071L6.79289 22.7071C6.98043 22.8946 7.23478 23 7.5 23H16.5C16.7652 23 17.0196 22.8946 17.2071 22.7071L22.7071 17.2071C22.8946 17.0196 23 16.7652 23 16.5V7.5C23 7.23478 22.8946 6.98043 22.7071 6.79289L17.2071 1.29289C17.0196 1.10536 16.7652 1 16.5 1H7.5ZM3 7.91421L7.91421 3H16.0858L21 7.91421V16.0858L16.0858 21H7.91421L3 16.0858V7.91421ZM11 6H13V14H11V6ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
                fill="#b80606"
            />
        </svg>
    );
};

export default DangerIcon;
